import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PortalAuthService } from '@portal-commons/portal-auth.service';
import { environment } from '@environment';

@Injectable()
export class GlobalOptionsInterceptor implements HttpInterceptor {
  constructor(private auth: PortalAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url !== environment.endpoints.getUnreadMessagesCount && req.url !== environment.endpoints.getPostboxMessages) {
      this.auth.updateLastRequest();
    }

    const authReq = req.clone({ withCredentials: true });
    return next.handle(authReq);
  }
}
